module.exports = __webpack_public_path__ + "img/thunder beat.b98e89c9.png";